module.exports = __webpack_public_path__ + "static/media/Italianno-Regular.95533958.ttf";